import { createContractRequest } from './helper';
/**
 * unsafe put offer - may overwrite the state in an unexpected way!
 */
export const putOfferUpdateAndRatingUnsafe = createContractRequest({
    route: '/contract/offers/:offerId/updateAndRating',
    method: 'put',
    source: 'data',
});
